module.exports = "/_next/static/images/star-default-2e11fd42.png";